import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import overDraftService, { Overdraft } from "../../services/overDraftService";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import Label from "../../components/controls/Label/Label";
import FormCommand from "../../components/controls/FormCommand/FormCommand";
import { useState } from "react";
import FormModal from "../../components/controls/FormModal";
import Frame from "../../components/controls/Frame/Frame";

export interface OverDraftListingPageProps {}

export default function OverDraftListingPage(props: OverDraftListingPageProps) {
  const navigate = useNavigate();
  const [od, setOd] = useState<Overdraft>();
  const [overdrafts, setOverDrafts] = useState<Overdraft[]>([]);

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h3>Overdrafts</h3>
            <GridView
              showAddButton={true}
              showSearchBar={true}
              keys={["name"]}
              name={"lstTransactions"}
              rowsPerPage={50}
              onAddRecord={() => setOd({})}
            >
              <GridView.Header>
                <tr>
                  <th>Account</th>
                  <th>Amount</th>
                  <th>Reason</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Rate</th>
                  <th></th>
                </tr>
              </GridView.Header>
              <GridView.Content>
                {overdrafts.map((d) => (
                  <tr>
                    <td>{d.accountName}</td>
                    <td>{d.amount}</td>
                    <td>{d.reason}</td>
                    <td>{d.startDate?.toDateString()}</td>
                    <td>{d.endDate?.toDateString()}</td>
                    <td>{d.rate}</td>
                    <td></td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {od && (
        <FormModal title="Overdraft Entry" onClose={() => setOd(undefined)}>
          <OverDraftForm />
        </FormModal>
      )}
    </>
  );
}

export interface OverDraftFormProps {}

export function OverDraftForm(props: OverDraftFormProps) {
  return (
    <div className="row">
      <div className="col">
        <FindAccount text="Account" id="account" />

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="amount" className="control-label">
                Amount
              </label>
              <input
                type="number"
                name="amount"
                id="amount"
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="loanSector" className="control-label">
                Sector
              </label>
              <select
                name="loanSector"
                id="loanSector"
                className="form-control form-control-sm"
              >
                <option value="">Select Sector</option>
              </select>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="endDate" className="control-label">
                End Date
              </label>
              <input
                type="date"
                name="endDate"
                id="endDate"
                className="form-control form-control-sm"
                readOnly
              />
            </div>
          </div>

          <div className="col">
            <div className="form-group">
              <label htmlFor="rate" className="control-label">
                Rate
              </label>
              <input
                type="number"
                name="rate"
                id="rate"
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <Label text="Narration" name="narration" />
          <input
            type="text"
            name="narration"
            id="narration"
            className="form-control form-control-sm"
            placeholder="Enter narration e.g (BEING OVERDRAFT GRANTED TO ...)"
          />
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
